import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="about" className="bg-white py-20 lg:py-32">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-16 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        {/* Images */}
        <div className="relative h-[440px] sm:h-[520px] lg:h-[560px] w-full">
          <div className="absolute top-0 left-0 w-[72%] h-[82%] overflow-hidden rounded-lg img-zoom">
            <img
              src="https://downsconstructionllc.com/images/aboutimg1-850w.jpeg"
              alt="construction team at work"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="absolute bottom-0 right-0 w-[54%] h-[56%] overflow-hidden rounded-lg border-4 border-white img-zoom">
            <img
              src="https://downsconstructionllc.com/images/aboutimg2a-850w.jpeg"
              alt="renovation project"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
          {/* Decorative accent */}
          <div className="absolute top-4 left-4 w-[72%] h-[82%] border-2 border-primary/20 rounded-lg -z-10"></div>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-5 lg:gap-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-0.5 bg-primary animate-lineGrow"></div>
            <span className="text-primary text-xs font-bold uppercase tracking-[0.3em]">About Us</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase text-gray-900 leading-tight" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            Over 29 Years of Construction Excellence
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            With nearly three decades in the trades, we bring unmatched craftsmanship, professionalism, and passion to every project. We believe in continuous improvement and operate with purpose-driven leadership.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Our team delivers clean, organized work with a focus on long-term quality and strong customer relationships. We don&apos;t just build structures—we build trust.
          </p>

          {/* Quote */}
          <div className="relative bg-primary-dark rounded-lg p-6 lg:p-7 mt-2">
            <div className="absolute top-3 right-5 text-5xl text-white/10 font-serif leading-none">&ldquo;</div>
            <p className="text-white text-sm leading-relaxed italic mb-4">
              &ldquo;We&apos;re driven by purpose, guided by integrity, and committed to excellence in every detail.&rdquo;
            </p>
            <div>
              <span className="text-primary-light font-bold text-sm uppercase tracking-wider">Brian Downs Jr</span>
              <span className="text-gray-400 text-xs ml-2">— Founder</span>
            </div>
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white text-xs font-bold uppercase tracking-widest px-7 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap w-fit mt-2 btn-press group"
          >
            More About Us
            <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
